import React, { Component } from 'react';
import moment from 'moment-timezone';
import logo from '../../assets/images/dashboard/logo.png'


export default class InvoiceDownload extends Component {
    state = {
        myOrder: {},
    }

    componentDidMount() {
        console.log(this.props.id)
        if (localStorage.getItem('userInfo')) {
            const frontUser = localStorage.getItem('userInfo')
            const obj = JSON.parse(frontUser)
            this.setState({ 'userInfo': obj })
            const userId = obj._id;
            console.log("userId");
            console.log(userId);

            const lastSegment = this.props.id;

            if (userId) {
                const url = `${process.env['REACT_APP_HOST']}/api/orders/single/${lastSegment}/`
                const params = {
                    method: 'GET',
                    headers: { 'Contenet-Type': 'appliaction/json', },
                };
                fetch(url, params)
                    .then((response) => response.json())
                    .then(data => {
                        console.log("data")
                        console.log(data)
                        this.setState({ myOrder: data.length == 1 ? data[0] : {} });
                        // console.log(this.state.myOrder.paymentResult.type);
                        // console.log(this.state.myOrder.orderItems);

                    });
            }
        }
    }

    printDocument() {
        var printContents = document.getElementById("divtoprint").innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        // document.body.innerHTML = originalContents;
        window.location.reload()
        // window.print()
    }

    render() {
        return (
            <>
                <div className="divToPrint" id="divtoprint">
                    <div style={{ background: '#fff', padding: '20px', maxWidth: '950px', margin: '0 auto', boxShadow: '0px 0px', fontFamily: 'Arial, Helvetica, sans-serif' }}>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                            <img src={logo} alt="logo" style={{ width: '200px' }} />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {/* <button style="padding: 8px 15px; border: 1px solid rgb(100, 100, 100); background-color: green; color: #fff; margin: 0px 5px;"><i class="fa fa-print"></i> Print</button> */}

                            </div>
                        </div>
 
                        <p>Purchase on {moment.tz(new Date(this.state.myOrder.createdAt), 'Europe/London').format('DD/MM/YYYY hh:mm A z')}</p>
                        <hr />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                            <div>
                                <p>From : <strong>VLF</strong></p>
                                <p>Address : --</p>
                                <p>Phone : --</p>
                                <p>Email : -- </p>
                            </div>
                            <div>
                                <p>To : <strong>{this.state.myOrder.firstName} {this.state.myOrder.lastName}</strong></p>
                                <p>Address : {this.state.myOrder.country}</p>
                                <p>Phone : {this.state.myOrder.mobileNo}</p>
                                <p>Email : {this.state.myOrder.email}</p>
                            </div>
                            <div>
                                <p><strong>Order Id : </strong> {this.state.myOrder.invoiceId} </p>
                                <p ><strong>Transaction Id : </strong> pay_HMpdyX9ExaZrkvy </p>
                                <p ><strong>Payment Mode : </strong> Online </p>
                                <p ><strong>Currency : </strong> EUR </p>
                                <p ><strong>Payment Status : </strong> Recieved </p>
                            </div>
                        </div>

                        <table >
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid #ccc', padding: '5px 10px' }}>Courses</th>
                                    <th style={{ border: '1px solid #ccc', padding: '5px 10px' }}>Name</th>
                                    <th style={{ border: '1px solid #ccc', padding: '5px 10px' }}>Currency</th>
                                    <th style={{ border: '1px solid #ccc', padding: '5px 10px' }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(this.state.myOrder._id != undefined) ?

                                    this.state.myOrder.productinfo.map(item =>

                                        <tr>
                                            <td style={{ border: '1px solid #ccc', padding: '5px 10px' }}>{item.name} </td>
                                            <td style={{ border: '1px solid #ccc', padding: '5px 10px' }}>{this.state.myOrder.firstName + ' ' + this.state.myOrder.lastName}</td>
                                            <td style={{ border: '1px solid #ccc', padding: '5px 10px' }}>EUR</td>
                                            <td style={{ border: '1px solid #ccc', padding: '5px 10px' }}>{item.price}</td>
                                        </tr>

                                    ) : null
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
                <br />
                <hr />
                <div class="btn-group mx-auto text-center" style={{margin:'0 auto', display:'block'}} role="group" aria-label="First group">
                    <button onClick={this.printDocument} style={{ padding: '8px 15px', border: '1px solid rgb(100, 100, 100)', backgroundColor: 'yellow', cursor:'pointer', borderRadius:'5px' }} ><i class="fa fa-print"></i> Print</button>
                    <button type="button" onClick={() => this.props.goBack()} class="btn btn-secondary" style={{padding:'9px 16px', marginTop:'-1px', display:'inline-block', marginLeft:'10px', borderRadius:'5px'}}>Back</button>

                </div>
            </>

        );
    }
}


// export default Invoice;